import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCrossIconSecondary from './svgs/CrossIconSecondary.js';
import SvgCrossIcon from './svgs/CrossIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var CrossIcon = (props => useIcon(SvgCrossIcon, SvgCrossIconSecondary, props));

export { CrossIcon as default };
